import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const FresherjobsFbd = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Fresher Jobs in Faridabad | Latest Job Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest fresher jobs in Faridabad NCR for graduates and students. Apply for IT, Marketing, Finance, HR, and Sales jobs in top companies hiring freshers in Faridabad."
        />
        <meta
          name="keywords"
          content="fresher jobs in Faridabad, fresher jobs in Faridabad NCR, jobs for freshers in Faridabad, IT fresher jobs Faridabad, marketing fresher jobs Faridabad, graduate jobs Faridabad, entry-level jobs Faridabad"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://jobsindelhincr.in/fresher-jobs-in-faridabad" />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Fresher Jobs in Faridabad – Latest Job Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for the latest <strong>fresher jobs in Faridabad</strong>? Explore
          thousands of opportunities in IT, Marketing, Finance, Education,
          Healthcare, and more. Whether you’re a graduate or a student, find your
          first job in Faridabad NCR today and kickstart your career.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Freshers in Faridabad
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Infosys</li>
          <li>Wipro</li>
          <li>Tech Mahindra</li>
          <li>HCL</li>
          <li>Accenture</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Job Categories Available
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Software Development Jobs in Faridabad</li>
          <li>Marketing Jobs in Faridabad</li>
          <li>Finance Jobs in Faridabad</li>
          <li>Sales Jobs in Faridabad</li>
          <li>Full-time Jobs in Faridabad</li>
          <li>Web Development Jobs in Faridabad</li>
          <li>Digital Marketing Jobs in Faridabad</li>
          <li>Telecalling Jobs in Faridabad</li>
          <li>IT Jobs in Faridabad</li>
          <li>Technical Support Jobs in Faridabad</li>
          <li>App Development Jobs in Faridabad</li>
          <li>HR Jobs in Faridabad</li>
          <li>Fresher Jobs in Faridabad</li>
          <li>Frontend Developer Jobs in Faridabad</li>
          <li>Backend Developer Jobs in Faridabad</li>
          <li>Full Stack Developer Jobs in Faridabad</li>
        </ul>

        <p className="text-gray-600">
          Start your career with <strong>jobsindelhincr.in</strong> – your trusted
          platform to find verified <strong>fresher job openings</strong> in Faridabad.
          No registration required – apply directly to companies hiring today!
        </p>
      </div>

      <Footer />
    </>
  );
};

export default FresherjobsFbd;
